import * as React from "react";
import type { SVGProps } from "react";
const SvgShieldWithPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.995 22H12h-.01zM12 16c-.55 0-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V7c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1h-3v3c0 .55-.45 1-1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.51 21.87c.149.09.317.13.485.13q.252 0 .475-.12l.079-.044c.489-.272 3.024-1.683 4.331-2.806 2.01-1.73 4.14-4.76 4.12-8.04v-7c0-.41-.26-.79-.65-.93-1.85-.69-5.19-1.1-8.51-1.06-3.57.05-6.55.44-8.2 1.07-.39.15-.64.52-.64.94.007.687.004 1.452.002 2.247L3 7.5v3.51c.02 2.74 1.69 5.92 4.3 8.12 1.38 1.16 4.09 2.68 4.21 2.74M5.01 4.74c1.53-.41 4.06-.69 6.86-.72 3.03-.04 5.62.31 7.14.73v6.27c.01 2.14-1.33 4.7-3.47 6.55-.9.77-2.67 1.81-3.52 2.29-.83-.48-2.52-1.5-3.46-2.29-2.11-1.78-3.54-4.42-3.55-6.57z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShieldWithPlus;
